export default "__VITE_ASSET___mQVc7Dc__"